import * as React from 'react';

import { Container } from 'components/container/Container';

import s from './Segment.scss';

interface IProps {
  children: React.ReactNode;
  container?: boolean;
  isColumnLayout?: boolean; // static padding or fluid (article);
  separator?: boolean;
  separatorOffset?: boolean; // if has a separator, isnt column layout but should be offset left
  noSpacing?: boolean;
  noSpacingBottom?: boolean;
}

export const Segment = ({
  children,
  container = false,
  separator = false,
  isColumnLayout = true, // spacing specific to narrow column
  separatorOffset = true,
  noSpacing,
  noSpacingBottom,
}: IProps) => {
  const content = container ? <Container>{children}</Container> : children;

  return (
    <section className={s('segment', {
      isColumnLayout,
      separator,
      separatorOffset: !isColumnLayout && separatorOffset && separator,
      noSpacing,
      noSpacingBottom,
    })}>
      {content}

      {separator && (
        <div className={s.segment__separator}>
          <span className={s.segment__separatorInner}>
            <span />
          </span>
        </div>
      )}
    </section>
  );
};
